import { Intent } from '@applyboard/crystal-ui/lib/types/design'

import { ApplicationDetailsStatus } from '../types'

export function getTagInformation(status: ApplicationDetailsStatus | string, activeRecord?: boolean): {
  label: string
  intent: Intent
} {
  if (activeRecord === false) {
    return {
      label: 'Invalid',
      intent: 'secondary',
    }
  } else {
     switch (status) {
    case 'ACCEPTED':
      return {
        label: 'Accepted',
        intent: 'positive',
      }
    case 'DECLINED':
      return {
        label: 'Declined',
        intent: 'negative',
      }
    case 'REJECTED':
      return {
        label: 'Rejected',
        intent: 'negative',
      }
    case 'PENDING':
    default:
      return {
        label: 'Pending',
        intent: 'warning',
      }
  }
  }
 
}
